export default {
    seo: {
        home: {
            title: "CodePro - Learn Programming Interactively",
            description: "Learn programming through interactive lessons."
        },
        notFound: {
            title: "Page Not Found - CodePro",
            description: "The page you are looking for does not exist."
        }
    },

    home: {
        heading: "Learn Programming Interactively",
        subtitle: "Interactive exercises and coding challenges.",
        downloadBazaar: "",
        downloadMyket: "",
        downloadUrlBazaar: "",
        downloadUrlMyket: ""
    },

    notFound: {
        heading: "The page you are looking for could not be found.",
        imageAlt: "Page not found"
    },

    codepro: {
        why: 'The goal of creating the Codepro platform is to make learning and teaching programming faster and easier while providing an outstanding experience for users.',
        social: 'Social Network',
        support: 'Support',
        terms: 'Terms & Privacy Policy',
        feedback: 'Feedback',
        usefullinks: 'Useful links',
        blog: 'Blog',
        allrights: 'All rights',
        reserved: 'reserved',
    },

    menu: {
        navItems: [
            { label: 'Blog', to: '/en/blog/' },
            { label: 'Course', to: '/en/course/' },
        ]
    },

    blog: {
        title: 'Codepro Blog: A Place To Learn CS More.',
        not_found: 'Blog Page Not Found...',
        tableOfContents: 'Table of Contents',
        team: 'Codepro',
        lastUpdated: 'Last Updated',
        readTime: 'Time To Read',
        share: 'Share',
        minutes: 'Minutes',
    },

    utils: {
        after: 'Next',
        before: 'Previous',
    }
}